import { useEffect } from 'react';
import { useAtom } from 'jotai';

import { userInformationAtom } from '../stores/UserStore';
import { remote_getMyProfile } from '../common/typescript/apis/ProfileAPIs';
import { User_Base } from '~/common/typescript/models/User';

const UserStoreController = () => {
  const [loggedUser, setLoggedUserStore] = useAtom(userInformationAtom);

  useEffect(() => {
    if (localStorage.getItem('jwt')) {
      remote_getMyProfile().then((response: User_Base) => {
        let user = response;
        setLoggedUserStore(user);
      });
    }
  }, [localStorage.getItem('jwt')]);

  return <></>;
};

export default UserStoreController;
